import { StripeBalanceAmount } from '@/types/stripe';

import { useStripeMonthlyPayments } from '@/api/endpoints/stripe/useStripeMonthlyPayments';
import { CurrencyDollarCircleIcon } from '@/assets/icons/CurrencyDollarCircleIcon';

import DashboardStatsCard from './DashboardStatsCard';

interface DashboardStripeBalanceProps {
  isLoading?: boolean;
}

const DashboardStripeBalance: React.FC<DashboardStripeBalanceProps> = ({ isLoading = false }) => {
  const { data: monthlyPaymentsData, isLoading: isPaymentsLoading } = useStripeMonthlyPayments();

  // Format balance for display
  const formatBalance = (amount: number, currency: string): string =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency.toUpperCase(),
    }).format(amount / 100); // Stripe amounts are in cents

  const getMonthlyPaymentsDisplay = (): string => {
    if (!monthlyPaymentsData?.payments?.length) return '$0.00';

    // Return formatted payments
    return monthlyPaymentsData.payments
      .map(({ currency, amount }: StripeBalanceAmount) => formatBalance(amount, currency))
      .join(', ');
  };
  if (getMonthlyPaymentsDisplay() === '$0.00') return null;

  return (
    <DashboardStatsCard
      isLoading={isLoading || isPaymentsLoading}
      Icon={<CurrencyDollarCircleIcon />}
      stats={[
        {
          label: 'Total Rent Collected This Month',
          type: 'success',
          value: getMonthlyPaymentsDisplay(),
          hideCount: true,
        },
      ]}
    />
  );
};

export default DashboardStripeBalance;
